// extracted by mini-css-extract-plugin
export default {"price":"w6-z","onSale":"x6-z","msrpLabelPrice":"y6-z","msrpLabel":"z6-z","originalPrice":"A6-z","percentOff":"B6-z"};